// ErrorBoundary.jsx
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    if (this.props.onError) this.props.onError(error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    if (this.props.onRetry) this.props.onRetry();
  };

  render() {
    const { hasError, error } = this.state;
    const { fallback: CustomFallback, children } = this.props;

    if (hasError) {
      if (CustomFallback) {
        return <CustomFallback error={error} onRetry={this.handleRetry} />;
      }
      // Default fallback if none provided
      return <div>Something went wrong</div>;
    }

    return children;
  }
}

export default ErrorBoundary;
